import React from "react";
import { useLang } from "../LanguageContext";

export default function Marquee() {
  const { t } = useLang();
  const text = t.marquee;
  const items = Array.from({ length: 6 });

  return (
    <div
      data-testid="marquee-section"
      className="overflow-hidden bg-[#EBE7DD] border-y border-[#23211E]/10 py-6"
    >
      <div className="flex whitespace-nowrap marquee-track">
        {items.map((_, i) => (
          <span
            key={i}
            className="font-serif italic text-2xl md:text-3xl text-[#23211E]/70 mx-10"
          >
            {text} <span className="text-[#B85532] mx-6">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
